var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var assembleLinksOrderedByHighlightedLast = function (nodes, nodePositions, highlightedNodeIds, expandedNodeIds, hiddenLinkTypes) {
    var grayLinks = [];
    var highlightedLinks = [];
    nodes
        .filter(function (leftNode) { return expandedNodeIds.includes(leftNode.id); })
        .forEach(function (leftNode) {
        leftNode.links
            .filter(function (link) { return link.label === undefined || !hiddenLinkTypes.includes(link.label); })
            .forEach(function (rightLink) {
            var _a, _b;
            var link = {
                id: "link-" + leftNode.id + "-" + rightLink.nodeId,
                leftPosition: (_a = nodePositions[leftNode.id]) === null || _a === void 0 ? void 0 : _a.rightAnchor,
                rightPosition: (_b = nodePositions[rightLink.nodeId]) === null || _b === void 0 ? void 0 : _b.leftAnchor,
                highlighted: highlightedNodeIds.includes(leftNode.id) && highlightedNodeIds.includes(rightLink.nodeId),
                label: rightLink.label,
            };
            link.highlighted ? highlightedLinks.push(link) : grayLinks.push(link);
        });
    });
    return __spreadArray(__spreadArray([], grayLinks, true), highlightedLinks, true);
};
//# sourceMappingURL=assembleLinks.js.map